
import { Prop, Watch } from "vue-property-decorator";
import { mixins, Options, Vue } from "vue-class-component";
import WithModel from "@/mixins/withModel";

@Options({
    inheritAttrs: false
})
export default class passwordInput extends mixins(WithModel) {

    showPassword: boolean = false;

}
